export function show_expert_profile_menu()
{
    if( document.querySelector( '.open_close_menu' )!== null && document.querySelector( '.open_close_menu' )!== undefined )
    {
        let openCloseMenu = document.querySelector( '.open_close_menu' );
        let expertProfileMenu = document.querySelector( '.experts_panel_top_menu' );
        openCloseMenu.addEventListener( 'click', ev=>{
            ev.preventDefault();
            if( expertProfileMenu.classList.contains( 'show_panel' ) )
            {
                expertProfileMenu.classList.remove( 'show_panel' );
                openCloseMenu.querySelector( 'span' ).classList.remove( 'fa-arrow-alt-circle-up' );
                openCloseMenu.querySelector( 'span' ).classList.add( 'fa-arrow-alt-circle-down' );
            }else{
                expertProfileMenu.classList.add( 'show_panel' );
                openCloseMenu.querySelector( 'span' ).classList.remove( 'fa-arrow-alt-circle-down' );
                openCloseMenu.querySelector( 'span' ).classList.add( 'fa-arrow-alt-circle-up' );
            }


        } );
    }
}